import {
    Component,
    OnInit,
    ViewChild,
    Output,
    EventEmitter,
  } from "@angular/core";
  import { BsModalService } from "ngx-bootstrap/modal";
  import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
  import { IOption } from "ng-select";
  import { NgForm } from "@angular/forms";
  import { NgModule } from "@angular/core";
  import { FormsModule } from "@angular/forms";
  import { Router } from "@angular/router";
  import { HelperService } from "../../services/helper.service";
  import Swal from "sweetalert2/dist/sweetalert2.js";
  import { ConfigurationService } from "../../services/configuration.service";
  import { ObjectivesService } from "../../services/objectives.service";
  import { TosterMessageService } from "../../services/toster-message.service";

  
  @Component({
    selector: "app-objectives-edit-approvalsettings-modal.component",
    templateUrl: "./objectives-edit-approvalsettings-modal.component.html",
    providers: [ConfigurationService, ObjectivesService],
  })
  export class ObjectivesEditApprovalSettingsModalComponent implements OnInit {
    public masterData: any = {};
    @Output() public ObjectiveRatingMasterReload: EventEmitter<any> =
      new EventEmitter<any>();
  
    formData = {
      description: "",
      //   active: 0,
    };
  
 
    isEdit: number;
    public items: Array<IOption> = [];
    public allApprovalRoles: Array<IOption> = [];
    public referenceStatus: Array<IOption> = [];
    public levelStatus: Array<IOption> = [];
    auto_id: number;

    activeStatus = [
      { value: 0, label: "Not Active" },
      { value: 1, label: "Active" },
    ];



    @ViewChild("form") form: NgForm;
    @ViewChild("swalModal") swalModal: any;
    @ViewChild("errorMessageHtml") errorMessageHtml: any;
  
    public successMsg: string = "";
    public htmlErrorMessage: string = "";
    selectedCompanySystemID = this.helperService.getSelectedCompanyId();
    companySystemID = +this.helperService.getSelectedCompanyId();
    // languageSystemID = +this.helperService.getAvailableLang();
  

  
    constructor(
      private router: Router,
      public bsModalRef: BsModalRef,
      private modalService: BsModalService,
      private helperService: HelperService,
      private configurationService: ConfigurationService,
      private objectivesService: ObjectivesService,
      private tosterMessageService: TosterMessageService,
    ) {}
  
    showErrorHtml() {
      setTimeout(() => {
        this.errorMessageHtml.show();
      }, 0);
    }
  
    closeModal() {
      this.bsModalRef.hide();
      this.modalService.setDismissReason("questionbank_closed");
    }
  
    closeModalAfterCreate() {
      this.bsModalRef.hide();
      this.modalService.setDismissReason("questionbank_closed");
    }
  
    showSuccessHtml() {
      setTimeout(() => {
        this.swalModal.show();
      }, 0);
    }
  
    ngOnInit() {}
  
  
  
  

    editApprovalSettings() {
      let that = this;
      const requestData = {
        auto_id: that.auto_id,
        items: that.items,
      };
      //console.log(requestData);

      that.objectivesService
        .editApprovalSettings()
        .post(requestData)
        .subscribe(
          (resp: any) => {
            //console.log(resp);
            that.masterData = {};
            // that.successMsg = "";
            // that.successMsg = "Successfully updated template headerr";
            // that.showSuccessHtml();
            this.tosterMessageService.showSuccess(
              "Success",
              "Successfully updated approval settings."
            );
            that.closeModalAfterCreate();
            this.ObjectiveRatingMasterReload.emit();
          },
          (error) => {
            that.htmlErrorMessage = "";
            if (error.status == 500) {
              that.htmlErrorMessage = error.data.message;
              that.showErrorHtml();
            } else if (error.status == 422) {
              that.htmlErrorMessage = that.helperService.serverSideError422(
                error.data.message
              );
              that.showErrorHtml();
              this.ObjectiveRatingMasterReload.emit();
            }
          }
        );
      this.ObjectiveRatingMasterReload.emit();
    }



    getStatusPlaceholder(active: number): string {
      return active === 1 ? 'Active' : 'Not Active';
    }
  

    getLevelPlaceholder(level_no: number): string {
      if (level_no === 1) {
        return 'Level 1';
      } else if (level_no === 2) {
        return 'Level 2';
      } else if (level_no === 3){
        return 'Level 3';
      } else {
        return 'Level 4';
      }
    }
    
  
    
  }
  


// WEBPACK FOOTER //
// /app/src/app/competancy/objectives-edit-approvalsettings-modal/objectives-edit-approvalsettings-modal.component.ts